var $cc1bf99c20c38a3a$exports = {};
$cc1bf99c20c38a3a$exports = {
    "collectionLabel": `Predlogi`
};


export {$cc1bf99c20c38a3a$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
